import { lazy, Suspense, useState } from "react";
import ConciergeOrb from "./ConciergeOrb";
import { useLang } from "../../i18n/LanguageContext";

const ChatSession = lazy(() => import("./ChatSession"));

export const ConciergeWidget = () => {
  const [open, setOpen] = useState(false);
  const { t, lang } = useLang();

  return (
    <>
      {open && (
        <Suspense fallback={null}>
          <ChatSession t={t} lang={lang} />
        </Suspense>
      )}
      <ConciergeOrb open={open} onToggle={() => setOpen((v) => !v)} label={t.concierge.label} />
    </>
  );
};

export default ConciergeWidget;
